<div class="modal-content boat-modal">
  <div class="d-flex justify-content-between align-items-start">
    <p class="usb-modal-text--title pr-5">{{ title }}</p>
    <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
      <span aria-hidden="true" style="font-size: 60px; font-weight: 100">&times;</span>
    </button>
  </div>

  <div *ngIf="action !== 'comments'" class="boat-tabs d-flex my-3">
    <button
      *ngFor="let item of tabs; let last = last"
      type="button"
      class="btn-tabs w-100"
      [class.border-right]="!last"
      [ngStyle]="{ color: tab === item.key ? buttonColorActive : buttonTextActive }"
      (click)="tab = item.key"
    >
      {{ item.label }}
    </button>
  </div>

  <!-- EMBARCACIÓN -->
  <div *ngIf="tab === 'boat'" class="boat-card" [style.border-color]="clientSetting?.clients_setting_global?.color_main_1">
    <div class="boat-card__header">
      <p class="field-value">Tipo de Embarcación</p>
      <div class="d-flex align-items-center" style="gap: 0.75em">
        <p class="boat-card__title">{{ title }}</p>
        <span *ngIf="details?.isEco" class="eco-badge">eco <i class="fas fa-leaf"></i></span>
      </div>
    </div>

    <div class="boat-card__body">
      <div class="boat-summary d-flex">
        <div class="d-flex flex-column" style="gap: 1em">
          <img class="boat-card__image" [src]="coverImage" alt="Imagen de la embarcación" (click)="tab = 'photos'" />
          <div *ngIf="logo" class="boat-card__logo">
            <img [src]="logo" [alt]="boat?.providerName" />
          </div>
        </div>

        <div class="boat-grid w-100">
          <div class="boat-grid__name">
            <p class="boat-card__name">{{ title }}</p>
            <p class="field-value">{{ info?.availability?.boardName }}</p>
          </div>

          <div>
            <p class="field-label">Puerto</p>
            <p class="field-value">{{ info?.bases?.from || info?.location }}</p>
          </div>
          <div>
            <p class="field-label">Cabinas</p>
            <p class="field-value">{{ details?.cabinCount || 0 }} Cabinas <span *ngIf="info?.skipper?.included">(+1p Capitán)</span></p>
          </div>
          <div>
            <p class="field-label">Capacidad</p>
            <p class="field-value">hasta {{ details?.peopleMax || 0 }} personas</p>
          </div>

          <hr class="boat-grid__divider" />

          <div>
            <p class="field-label">Régimen</p>
            <p class="field-value">{{ info?.availability?.boardName || "N/A" }}</p>
          </div>
          <div>
            <p class="field-label">Condiciones</p>
            <p class="field-value field-value--strong" [class.text-refundable]="isRefundable" [class.text-danger-price]="!isRefundable">
              {{ isRefundable ? "REEMBOLSABLE" : "NO REEMBOLSABLE" }}
            </p>
          </div>
          <div>
            <p class="field-label">Baños</p>
            <p class="field-value">{{ details?.wc || 0 }} Baños</p>
          </div>
        </div>
      </div>

      <p class="section-title">Fechas disponibles</p>
      <div class="d-flex flex-column" style="gap: 1em">
        <div
          *ngFor="let opt of options"
          class="option-card"
          [class.option-card--selected]="opt === selectedOption"
          [style.border-color]="opt === selectedOption ? clientSetting?.clients_setting_global?.color_main_1 : null"
          (click)="selectOption(opt)"
        >
          <span *ngIf="isCheapest(opt)" class="cheapest-seal">MÁS <small>ECONÓMICO</small></span>

          <div class="d-flex align-items-start" style="gap: 0.75em">
            <input type="radio" name="boatOption" class="mt-1" [checked]="opt === selectedOption" />
            <div>
              <p class="field-label">Salida - Llegada</p>
              <p class="field-value field-value--strong">
                {{ opt.dateFrom | date: "dd MMM yyyy" }} - {{ opt.dateTo | date: "dd MMM yyyy" }}
              </p>
              <p class="field-value">{{ opt.days }} días</p>
              <p *ngIf="opt.isInDateRange === false" class="field-value field-value--muted">Fechas cercanas a tu búsqueda</p>
            </div>
          </div>

          <div>
            <p class="field-label">Tarifa por Día</p>
            <div class="d-flex align-items-center">
              <p class="field-price">
                {{ currencyAgency?.code }}
                {{ opt.pricePerDay | currencyConverterPure: opt.currency : currencyAgency?.code : currencies | number: "1.2-2" }}
              </p>
              <usb-tooltip-convert-amount
                [clientsSettingAppBooking]="clientSetting"
                [currencyProduct]="opt.currency"
                [valueProduct]="opt.pricePerDay"
              ></usb-tooltip-convert-amount>
            </div>
            <p class="field-value">imp. incluidos</p>
          </div>

          <div>
            <p class="field-label">Total Estadía</p>
            <div class="d-flex align-items-center">
              <p class="field-price">
                {{ currencyAgency?.code }}
                {{ opt.priceGross | currencyConverterPure: opt.currency : currencyAgency?.code : currencies | number: "1.2-2" }}
              </p>
              <usb-tooltip-convert-amount
                [clientsSettingAppBooking]="clientSetting"
                [currencyProduct]="opt.currency"
                [valueProduct]="opt.priceGross"
              ></usb-tooltip-convert-amount>
            </div>
            <p class="field-value">imp. incluidos</p>
          </div>

          <div>
            <p class="field-label">Importe</p>
            <p class="field-value">Alquiler del Barco</p>
            <p class="field-price">{{ opt.currency }} {{ (opt.discount?.priceWithoutDiscounts || opt.priceGross) | number: "1.2-2" }}</p>
            <ng-container *ngIf="opt.discount?.value > 0">
              <p class="field-value mt-1">Descuento ({{ opt.discount.percentage }}%)</p>
              <div class="d-flex align-items-center">
                <p class="field-price text-danger-price">- {{ opt.currency }} {{ opt.discount.value | number: "1.2-2" }}</p>
                <usb-tooltip-convert-amount
                  [clientsSettingAppBooking]="clientSetting"
                  [currencyProduct]="opt.currency"
                  [valueProduct]="opt.discount.value"
                ></usb-tooltip-convert-amount>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <p *ngIf="!selectedOption" class="select-hint">Selecciona una semana para ver sus extras y el resumen de pago.</p>

      <ng-container *ngIf="mandatoryExtras.length > 0">
        <p class="section-title">
          Extras Obligatorios en el Barco <span *ngIf="allPayOnSite(mandatoryExtras)">(a pagar en destino)</span>
        </p>
        <div class="extras-grid">
          <label *ngFor="let extra of mandatoryExtras" class="extra-item extra-item--locked">
            <input type="checkbox" checked disabled />
            <ng-container *ngTemplateOutlet="extraDetail; context: { $implicit: extra }"></ng-container>
          </label>
        </div>
      </ng-container>

      <ng-container *ngIf="optionalExtras.length > 0">
        <p class="section-title">
          Extras Opcionales en el Barco <span *ngIf="allPayOnSite(optionalExtras)">(a pagar en destino)</span>
        </p>
        <div class="extras-grid">
          <label *ngFor="let extra of optionalExtras" class="extra-item">
            <input type="checkbox" [checked]="selectedExtras.has(extra.extraid)" (change)="toggleExtra(extra)" />
            <ng-container *ngTemplateOutlet="extraDetail; context: { $implicit: extra }"></ng-container>
          </label>
        </div>
      </ng-container>

      <ng-template #extraDetail let-extra>
        <span class="usb-modal-text--body extra-item__title" [tooltip]="extra.description" placement="bottom">{{ extra.title }}</span>
        <span class="usb-modal-text--body-strong extra-item__price">
          ({{ extraCurrency(extra) }} {{ extraAmount(extra) | number: "1.2-2" }})
        </span>
      </ng-template>

      <ng-container *ngIf="info?.amenities?.length > 0">
        <button type="button" class="section-title section-title--toggle" (click)="showEquipment = !showEquipment">
          Equipamiento Disponible en el Barco
          <i class="bi" [ngClass]="showEquipment ? 'bi-caret-up-fill' : 'bi-caret-down-fill'"></i>
        </button>
        <div *ngIf="showEquipment" class="equipment-grid">
          <p *ngFor="let amenity of info.amenities" class="usb-modal-text--body mb-0">
            <i class="bi bi-check-circle mr-2"></i>{{ amenity.amenity_name }}
          </p>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- INFO -->
  <div *ngIf="tab === 'info'" class="boat-info">
    <ng-container *ngIf="info?.experience">
      <p class="usb-modal-text--subtitle semi-bold mb-2">{{ info.experience.title }}</p>
      <p class="usb-modal-text--body mb-4">{{ info.experience.description || boat?.description }}</p>
    </ng-container>
    <p *ngIf="!info?.experience" class="usb-modal-text--body mb-4">{{ boat?.description }}</p>

    <p class="usb-modal-text--body-strong mb-2">Ficha técnica</p>
    <div class="spec-grid mb-4">
      <p class="usb-modal-text--body mb-0"><b>Tipo:</b> {{ details?.typeName || "N/A" }}</p>
      <p class="usb-modal-text--body mb-0"><b>Año:</b> {{ details?.buildYear || "N/A" }}</p>
      <p class="usb-modal-text--body mb-0"><b>Eslora:</b> {{ details?.eslora ? details.eslora + " m" : "N/A" }}</p>
      <p class="usb-modal-text--body mb-0"><b>Motor:</b> {{ details?.engine || "N/A" }}</p>
      <p class="usb-modal-text--body mb-0"><b>Tipo de chárter:</b> {{ details?.charterType || "N/A" }}</p>
      <p class="usb-modal-text--body mb-0"><b>Literas:</b> {{ details?.berthCount || "N/A" }}</p>
      <p class="usb-modal-text--body mb-0"><b>Capacidad de agua:</b> {{ details?.waterCapacity ? details.waterCapacity + " L" : "N/A" }}</p>
      <p class="usb-modal-text--body mb-0"><b>Capacidad de combustible:</b> {{ details?.fuelCapacity ? details.fuelCapacity + " L" : "N/A" }}</p>
    </div>

    <p class="usb-modal-text--body-strong mb-2">Bases</p>
    <p class="usb-modal-text--body mb-0"><b>Salida:</b> {{ info?.bases?.from || "N/A" }}</p>
    <p class="usb-modal-text--body mb-4"><b>Llegada:</b> {{ info?.bases?.to || "N/A" }}</p>

    <ng-container *ngIf="selectedOption?.remarks?.length > 0">
      <p class="usb-modal-text--body-strong mb-2">Observaciones</p>
      <p *ngFor="let remark of selectedOption.remarks" class="usb-modal-text--body mb-0">{{ remark }}</p>
    </ng-container>
  </div>

  <!-- FOTOS -->
  <div *ngIf="tab === 'photos'">
    <usb-photos [images]="info?.images"></usb-photos>
  </div>

  <!-- COMENTARIOS -->
  <div *ngIf="tab === 'comments'">
    <usb-comments [clientSetting]="clientSetting" [payload]="payload" [productId]="boat?.productId" [action]="action" (closeModal)="close()">
    </usb-comments>
  </div>
  <!-- RESUMEN DE LA SEMANA ELEGIDA -->
  <div *ngIf="tab === 'boat' && selectedOption" class="summary-bar">
    <div>
      <p class="summary-bar__title">{{ title }}</p>
      <p class="field-value">
        {{ selectedOption.dateFrom | date: "dd MMM yyyy" }} - {{ selectedOption.dateTo | date: "dd MMM yyyy" }} ({{ selectedOption.days }} días)
      </p>
      <p *ngIf="selectedExtras.size > 0" class="field-value">{{ selectedExtras.size }} extra(s) opcional(es) seleccionado(s)</p>
    </div>

    <div class="d-flex align-items-center" style="gap: 2.5em">
      <div class="summary-bar__amount">
        <p class="field-value">Pago en línea</p>
        <div class="d-flex align-items-center">
          <p class="summary-bar__price">
            {{ currencyAgency?.code }}
            {{ onlineTotal | currencyConverterPure: selectedOption.currency : currencyAgency?.code : currencies | number: "1.2-2" }}
          </p>
          <usb-tooltip-convert-amount
            [clientsSettingAppBooking]="clientSetting"
            [currencyProduct]="selectedOption.currency"
            [valueProduct]="onlineTotal"
          ></usb-tooltip-convert-amount>
        </div>
        <p class="field-value">{{ selectedOption.currency }} {{ onlineTotal | number: "1.2-2" }}</p>
      </div>

      <div class="summary-bar__amount">
        <p class="field-value">A pagar en destino</p>
        <p class="summary-bar__price summary-bar__price--secondary">
          {{ currencyAgency?.code }}
          {{ onSiteTotal | currencyConverterPure: selectedOption.currency : currencyAgency?.code : currencies | number: "1.2-2" }}
        </p>
        <p class="field-value">{{ selectedOption.currency }} {{ onSiteTotal | number: "1.2-2" }}</p>
      </div>

      <button
        type="button"
        class="summary-bar__button"
        [style.background-color]="clientSetting?.clients_setting_global?.color_main_1"
        (click)="continue()"
      >
        Continuar
      </button>
    </div>
  </div>
</div>
